/** Battery Transparency™ — health, cycles, OEM origin, endurance, test date. */

export type BatteryTransparencyInput = {
  battery_health?: number | null
  battery_cycles?: number | null
  battery_original?: boolean | null
  battery_tested_at?: string | null
  manufacturer?: string | null
}

/** Mixed-use hours for a new battery, by brand (typical daily use). */
export function typicalNewBatteryHours(manufacturer?: string | null): number {
  const brand = (manufacturer || '').toLowerCase()
  if (brand.includes('apple')) return 14
  if (brand.includes('samsung')) return 16
  if (brand.includes('google')) return 13
  if (brand.includes('xiaomi') || brand.includes('redmi') || brand.includes('poco')) return 15
  if (brand.includes('oneplus')) return 16
  if (brand.includes('huawei') || brand.includes('honor')) return 14
  if (brand.includes('oppo') || brand.includes('realme') || brand.includes('vivo')) return 15
  if (brand.includes('motorola')) return 14
  return 13
}

export function estimateNormalUseEnduranceHours(
  healthPct: number | null | undefined,
  manufacturer?: string | null,
): number | null {
  if (healthPct == null || !Number.isFinite(healthPct) || healthPct <= 0) return null
  const pct = Math.min(100, Math.max(1, healthPct))
  const hours = typicalNewBatteryHours(manufacturer) * (pct / 100)
  return Math.round(hours * 10) / 10
}

export function batteryOemBrand(manufacturer?: string | null): string {
  const m = (manufacturer || '').trim()
  if (!m) return 'OEM'
  if (/apple/i.test(m)) return 'Apple'
  return m.split(/\s+/)[0]
}

export function formatBatteryTestedDate(
  iso: string | null | undefined,
  locale: string,
): string | null {
  if (!iso) return null
  const d = new Date(iso.length <= 10 ? `${iso}T12:00:00` : iso)
  if (Number.isNaN(d.getTime())) return null
  return d.toLocaleDateString(locale, { day: 'numeric', month: 'short', year: 'numeric' })
}

export function hasBatteryTransparency(input: BatteryTransparencyInput): boolean {
  return input.battery_health != null && input.battery_health > 0
}
